import React from 'react';
import CalendarMangementRouter from './MultilingualManagementRouter';

export default function MultilingualManagementPage() {
  return <CalendarMangementRouter />;
}
